export default "__VITE_ASSET__CI$fUm3Z__"